<template>
  <div>
    <v-card flat class="mb-5">
      <v-card-text class="black--text">
        <v-container class="pa-5">
          <list-kasek
            v-if="initValue && initValue.psp_peringkat_jenjang_id"
            ref="kasek"
            :detail="initValue"
            :type="type || ''"
            :is-edit="initValue && [2, 4].includes(initValue.k_proses_peringkat_psp)"
            :options="{ btnDownload: type === 'peringkat' }"
            @nilai="onSetNilai"
            @upload="onUploadNilai"
            @peringkat="onSetPeringkat"
            @download="onDownload"
          />
        </v-container>
      </v-card-text>
    </v-card>
    <popup-nilai v-if="formulir.kasek" ref="nilai" :kasek="formulir.kasek" :detail="initValue || {}" @save="onSave" />
    <popup-upload
      v-if="formulir.kasek"
      ref="upload"
      :kasek="formulir.kasek"
      :rules="{ format: 'xls', required: true }"
      format="XLXS/XLS"
      @template="onDownloadTemplate"
      @save="onSave"
    ></popup-upload>
    <popup-peringkat
      v-if="formulir.kasek"
      ref="peringkat"
      :kasek="formulir.kasek"
      :detail="formulir.init"
      @save="onSave"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ListKasek from '../../base/ListKasek';
import PopupNilai from '../popup/Nilai';
import PopupUpload from '../popup/Upload';
import PopupPeringkat from '../popup/Peringkat';
export default {
  components: { ListKasek, PopupNilai, PopupUpload, PopupPeringkat },
  props: {
    initValue: {
      default: () => null,
    },
    type: {
      default: '',
    },
  },

  data() {
    return {
      formulir: {},
      action: null,
    };
  },

  computed: {
    ...mapState('preferensi', {
      akun: (state) => Object.assign({}, state.data && state.data.akun),
      instansi: (state) => Object.assign({}, state.data && state.data.instansi),
    }),
  },

  methods: {
    ...mapActions('peringkat', ['save', 'download']),

    reset() {
      this.$set(this, 'formulir', {});
    },

    saveNilai() {
      let payloads = {
        id: this.initValue.psp_peringkat_jenjang_id,
        action: 'seleksi',
        type: 'save-nilai',
        params: { kandidats: this.$refs.nilai.getNilai() },
      };

      this.save(payloads).then(() => {
        this.$success('Nilai berhasil disimpan');
        this.$refs.nilai.close();
        this.$refs.kasek.onReload();
      });
    },

    uploadNilai() {
      const data = this.$refs.upload.getFile();
      const formData = new FormData();
      const id = this.initValue.psp_peringkat_jenjang_id;

      formData.append('file', data.file);
      formData.append('is_negeri', this.formulir.kasek.is_negeri);

      this.save({ action: 'seleksi', type: 'upload-nilai', id, params: formData, upload: true })
        .then(({ data }) => {
          if (data && data.errors) {
            const error = Object.values(data.errors) || [];
            this.$refs.upload.step = 1;
            this.$refs.upload.errorFile.push(...error);
            return;
          }

          this.$success('Data nilai KS berhasil diunggah');
          this.$refs.upload.close();
          this.$refs.kasek.onReload();
        })
        .catch(() => {
          this.$error('Terdapat kesalahan saat mengunggah berkas, silakan periksa berkas Anda kemudian coba kembali!');
        });
    },

    savePeringkat() {
      let payloads = {
        id: this.initValue.psp_peringkat_jenjang_id,
        action: 'seleksi',
        type: 'save-prioritas',
        params: this.$refs.peringkat.getParams(),
      };

      this.save(payloads).then(() => {
        this.$success('Prioritas berhasil disimpan');
        this.$refs.peringkat.close();
        this.$refs.kasek.onReload();
      });
    },

    onSetNilai(kasek) {
      this.action = 'set-nilai';
      this.$set(this.formulir, 'kasek', kasek || {});
      this.$nextTick(() => {
        this.$refs.nilai.open();
      });
    },

    onDownloadTemplate() {
      const id = this.initValue.psp_peringkat_jenjang_id;
      const is_negeri = this.formulir.kasek.is_negeri;

      this.download({ action: 'seleksi', type: 'nilai-template', id, params: { is_negeri } }).then((url) => {
        window.open(url, '_blank');
      });
    },

    onUploadNilai(kasek) {
      this.action = 'upload-nilai';
      this.$set(this.formulir, 'kasek', kasek || {});
      this.$nextTick(() => {
        this.$refs.upload.open();
      });
    },

    onSetPeringkat(kasek) {
      this.action = 'set-peringkat';
      this.$set(this.formulir, 'kasek', kasek || {});
      this.$set(this.formulir, 'init', null);

      this.$nextTick(() => {
        this.$set(this.formulir, 'init', this.initValue);
        this.$refs.peringkat.open();
      });
    },

    onDownload(params) {
      const id = this.initValue.psp_peringkat_jenjang_id;

      this.download({ action: 'seleksi', type: 'prioritas-download', id, params }).then((url) => {
        window.open(url, '_blank');
      });
    },

    onSave() {
      switch (this.action) {
        case 'set-nilai':
          this.saveNilai();
          break;
        case 'upload-nilai':
          this.uploadNilai();
          break;
        case 'set-peringkat':
          this.savePeringkat();
          break;
      }
    },
  },
};
</script>
